import { moveToFulfilled, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  AllNetworkGroupsLoadFulfilledAction,
  AllNetworkGroupsLoadMoreFulfilledAction,
} from '../../domains/allNetworkGroups/actions.types';
import { CreateEventFulfilledAction } from '../../domains/createEvent/actions.types';
import { CreateGroupCalendarInviteForBroadcastFulfilledAction } from '../../domains/createGroupCalendarInviteForBroadcast/actions.types';
import { EditEventFulfilledAction } from '../../domains/editEvent/actions.types';
import { EventLoadByBroadcastIdFulfilledAction } from '../../domains/eventLoadByBroadcastId/actions.types';
import {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../domains/feedLoad/actions.types';
import { FileUploadJobCompletedAction } from '../../domains/fileUploadJobs/actions.types';
import { FileLoadFulfilledAction } from '../../domains/files/loadActions.types';
import { FirstRunSuggestedGroupsLoadFulfilledAction } from '../../domains/firstRunSuggestedGroups/actions.types';
import { GroupAvatarCommitFulfilledAction } from '../../domains/groupAvatarUploads/actions.types';
import { GroupEventsSidebarLoadFulfilledAction } from '../../domains/groupEventsSidebarLoad/actions.types';
import { GroupHeaderLoadFulfilledAction } from '../../domains/groupHeaderLoad/actions.types';
import { GroupJoinedFulfilledAction, GroupLeftFulfilledAction } from '../../domains/groupJoinLeave/actions.types';
import { GuestUserAcceptGroupInvitationFulfilledAction } from '../../domains/groupJoinLeaveWhenInvited/actions.types';
import { GroupRelatedGroupsLoadFulfilledAction } from '../../domains/groupRelatedGroupsLoad/actions.types';
import { GroupSidebarLoadFulfilledAction } from '../../domains/groupSidebarLoad/actions.types';
import {
  GroupCreateFulfilledAction,
  GroupEditFulfilledAction,
  GroupLoadFulfilledAction,
} from '../../domains/groups/actions.types';
import { LiveEventLoadByGroupIdFulfilledAction } from '../../domains/liveEventLoadByGroupId/actions.types';
import { LiveEventLoadByNetworkFulfilledAction } from '../../domains/liveEventsLoadByNetwork/actions.types';
import { MessageLanguageSpecificContentLoadAction } from '../../domains/messageLanguageSpecificContent/actions.types';
import {
  GroupMarkAsMultiTenantOrganizationGroupFulfilledAction,
  GroupUnmarkAsMultiTenantOrganizationGroupFulfilledAction,
} from '../../domains/multiTenantOrganizationGroup/actions.types';
import { MyGroupsLoadFulfilledAction, MyGroupsLoadMoreFulfilledAction } from '../../domains/myGroups/actions.types';
import { NavigationGroupsLoadFulfilledAction } from '../../domains/navigationGroupsLoad/actions.types';
import {
  NestedThreadDeepLinkSecondLevelLoadFulfilledAction,
  NestedThreadDeepLinkTopLevelLoadFulfilledAction,
  NestedThreadLoadFulfilledAction,
} from '../../domains/nestedThread/types';
import { NestedThreadListLoadFulfilledAction } from '../../domains/nestedThreadList/actions.types';
import { MarkAllNotificationsAsSeenFulfilledAction } from '../../domains/notificationFeeds/actions.types';
import { NotificationLoadMoreFulfilledAction } from '../../domains/notificationPaginations/actions.types';
import {
  GroupMarkAsOfficialFulfilledAction,
  GroupUnmarkAsOfficialFulfilledAction,
  OfficialGroupsLoadFulfilledAction,
  OfficialGroupsLoadMoreFulfilledAction,
} from '../../domains/officialGroups/actions.types';
import {
  ThreadPinToEventFeedFulfilledAction,
  ThreadPinToGroupFeedFulfilledAction,
  ThreadPinToTeamsMeetingFeedFulfilledAction,
  ThreadUnpinFromEventFeedFulfilledAction,
  ThreadUnpinFromGroupFeedFulfilledAction,
  ThreadUnpinFromTeamsMeetingFeedFulfilledAction,
} from '../../domains/pinnedThreads/actions.types';
import { ExtractSuggestionsAction } from '../../domains/publisherSuggestions/types';
import {
  PublishDirectMessageFulfilledAction,
  PublishEventMessageFulfilledAction,
  PublishGroupMessageFulfilledAction,
  PublishPollMessageFulfilledAction,
  PublishPraiseMessageFulfilledAction,
  PublishReplyMessageFulfilledAction,
  PublishUserMessageFulfilledAction,
  PublishUserPollMessageFulfilledAction,
  PublishUserPraiseMessageFulfilledAction,
} from '../../domains/publishers/actions.types';
import {
  RecommendedGroupsLoadFulfilledAction,
  RecommendedGroupsLoadMoreFulfilledAction,
} from '../../domains/recommendedGroups/actions.types';
import { SearchLoadFulfilledAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';
import {
  SecondLevelRepliesLoadLastFulfilledAction,
  SecondLevelRepliesLoadNextFulfilledAction,
  SecondLevelRepliesLoadPreviousFulfilledAction,
} from '../../domains/secondLevelReplies/actions.types';
import { SuggestedActionsLoadFulfilledAction } from '../../domains/suggestedActions/actions.types';
import {
  SuggestedGroupsLoadFulfilledAction,
  SuggestedGroupsLoadMoreFulfilledAction,
} from '../../domains/suggestedGroups/actions.types';
import { SuggestedMyLeaderGroupsLoadFulfilledAction } from '../../domains/suggestedMyLeaderGroups/actions.types';
import { ThreadSharesLoadFulfilledAction } from '../../domains/threadShares/actions.types';
import {
  TopLevelRepliesLoadInitialFulfilledAction,
  TopLevelRepliesLoadLastFulfilledAction,
  TopLevelRepliesLoadNextFulfilledAction,
  TopLevelRepliesLoadPreviousFulfilledAction,
} from '../../domains/topLevelReplies/actions.types';
import { TypeaheadFulfilledAction } from '../../domains/typeahead/actions.types';
import { UserSidebarLoadFulfilledAction } from '../../domains/userSidebarLoad/actions.types';

import { Group, Groups } from './types';
export type GroupAction =
  | EventLoadByBroadcastIdFulfilledAction
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | FileLoadFulfilledAction
  | ThreadPinToEventFeedFulfilledAction
  | ThreadPinToGroupFeedFulfilledAction
  | ThreadPinToTeamsMeetingFeedFulfilledAction
  | ThreadUnpinFromEventFeedFulfilledAction
  | ThreadUnpinFromGroupFeedFulfilledAction
  | ThreadUnpinFromTeamsMeetingFeedFulfilledAction
  | PublishEventMessageFulfilledAction
  | PublishGroupMessageFulfilledAction
  | PublishUserMessageFulfilledAction
  | PublishUserPollMessageFulfilledAction
  | PublishUserPraiseMessageFulfilledAction
  | PublishDirectMessageFulfilledAction
  | PublishReplyMessageFulfilledAction
  | PublishPollMessageFulfilledAction
  | PublishPraiseMessageFulfilledAction
  | GroupHeaderLoadFulfilledAction
  | NavigationGroupsLoadFulfilledAction
  | GroupSidebarLoadFulfilledAction
  | TypeaheadFulfilledAction
  | GroupJoinedFulfilledAction
  | GuestUserAcceptGroupInvitationFulfilledAction
  | GroupLeftFulfilledAction
  | FileUploadJobCompletedAction
  | SearchLoadFulfilledAction
  | SearchLoadMoreFulfilledAction
  | MarkAllNotificationsAsSeenFulfilledAction
  | NotificationLoadMoreFulfilledAction
  | GroupAvatarCommitFulfilledAction
  | CreateEventFulfilledAction
  | EditEventFulfilledAction
  | GroupRelatedGroupsLoadFulfilledAction
  | RecommendedGroupsLoadFulfilledAction
  | RecommendedGroupsLoadMoreFulfilledAction
  | SuggestedActionsLoadFulfilledAction
  | FirstRunSuggestedGroupsLoadFulfilledAction
  | SuggestedGroupsLoadFulfilledAction
  | SuggestedGroupsLoadMoreFulfilledAction
  | GroupEventsSidebarLoadFulfilledAction
  | LiveEventLoadByGroupIdFulfilledAction
  | LiveEventLoadByNetworkFulfilledAction
  | GroupCreateFulfilledAction
  | GroupEditFulfilledAction
  | CreateGroupCalendarInviteForBroadcastFulfilledAction
  | NestedThreadLoadFulfilledAction
  | NestedThreadDeepLinkTopLevelLoadFulfilledAction
  | NestedThreadDeepLinkSecondLevelLoadFulfilledAction
  | NestedThreadListLoadFulfilledAction
  | TopLevelRepliesLoadInitialFulfilledAction
  | TopLevelRepliesLoadLastFulfilledAction
  | TopLevelRepliesLoadPreviousFulfilledAction
  | TopLevelRepliesLoadNextFulfilledAction
  | SecondLevelRepliesLoadPreviousFulfilledAction
  | SecondLevelRepliesLoadNextFulfilledAction
  | UserSidebarLoadFulfilledAction
  | GroupLoadFulfilledAction
  | SecondLevelRepliesLoadLastFulfilledAction
  | ThreadSharesLoadFulfilledAction
  | GroupMarkAsOfficialFulfilledAction
  | GroupUnmarkAsOfficialFulfilledAction
  | GroupMarkAsMultiTenantOrganizationGroupFulfilledAction
  | GroupUnmarkAsMultiTenantOrganizationGroupFulfilledAction
  | AllNetworkGroupsLoadFulfilledAction
  | AllNetworkGroupsLoadMoreFulfilledAction
  | MyGroupsLoadFulfilledAction
  | MyGroupsLoadMoreFulfilledAction
  | SuggestedMyLeaderGroupsLoadFulfilledAction
  | OfficialGroupsLoadFulfilledAction
  | OfficialGroupsLoadMoreFulfilledAction
  | ExtractSuggestionsAction
  | MessageLanguageSpecificContentLoadAction;

const allCompanyGroup: Group = {
  id: 'eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIwIn0',
  telemetryId: '0',
  networkId: '',
  name: '',
  isExternal: false,
  isMultiTenantOrganizationGroup: false,
  isOfficial: false,
  databaseId: '0',
  hasDefaultAvatar: true,
  guestsCount: 0,
  threadStarterSmallFileUploadUrl: '',
  isMoveThreadToThisGroupRestricted: false,
};

const initialState: Groups = {
  pending: { byId: {} },
  fulfilled: { byId: { [allCompanyGroup.id]: allCompanyGroup } },
  rejected: { byId: {} },
};

const updateGroupOfficial = (
  state: Groups,
  action: GroupMarkAsOfficialFulfilledAction | GroupUnmarkAsOfficialFulfilledAction,
  isOfficial: boolean
) => {
  const { groupId } = action.payload;
  const group = state.fulfilled.byId[groupId];

  return update(state, groupId, {
    ...group,
    isOfficial,
  });
};

const updateGroupIsMtoGroup = (
  state: Groups,
  action:
    | GroupMarkAsMultiTenantOrganizationGroupFulfilledAction
    | GroupUnmarkAsMultiTenantOrganizationGroupFulfilledAction,
  isMultiTenantOrganizationGroup: boolean
) => {
  const { groupId } = action.payload;
  const group = state.fulfilled.byId[groupId];

  return update(state, groupId, {
    ...group,
    isMultiTenantOrganizationGroup,
  });
};

// eslint-disable-next-line max-lines-per-function
const reducer: Reducer<Groups, GroupAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NAVIGATION_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'FEED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'FILE.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'SEARCH.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'THREAD.PIN_TO_EVENT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'THREAD.PIN_TO_GROUP_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'THREAD.PIN_TO_TEAMS_MEETING_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'THREAD.UNPIN_FROM_EVENT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'THREAD.UNPIN_FROM_GROUP_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'THREAD.UNPIN_FROM_TEAMS_MEETING_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'PUBLISHER.PUBLISH_EVENT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'PUBLISHER.PUBLISH_GROUP_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'PUBLISHER.PUBLISH_USER_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'PUBLISHER.PUBLISH_USER_POLL_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'PUBLISHER.PUBLISH_USER_PRAISE_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'PUBLISHER.PUBLISH_DIRECT_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'PUBLISHER.PUBLISH_REPLY_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'PUBLISHER.PUBLISH_POLL_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'PUBLISHER.PUBLISH_PRAISE_MESSAGE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'GROUP_HEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'GROUP_SIDEBAR.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'TYPEAHEAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'GROUP.JOINED_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'GROUP.GUEST_INVITE_ACCEPT_REQUEST_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'FILE_UPLOAD_JOB.COMPLETED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'MARK_ALL_NOTIFICATIONS_AS_SEEN.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'NOTIFICATION.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'GROUP_AVATAR_COMMIT.FULFILLED':
      return update(state, action.payload.groupId, {
        avatarUrlTemplate: action.payload.avatarUrlTemplate,
        hasDefaultAvatar: false,
      });
    case 'GROUP_EVENTS_SIDEBAR.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'CREATE_EVENT.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'EDIT_EVENT.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'EVENT.LOAD_BY_BROADCAST_ID_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'LIVE_EVENT.LOAD_BY_GROUP_ID_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'LIVE_EVENT.LOAD_BY_NETWORK_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'ALL_NETWORK_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'ALL_NETWORK_GROUPS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'GROUP_RELATED_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'RECOMMENDED_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'RECOMMENDED_GROUPS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'SUGGESTED_ACTION.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'FRE_SUGGESTED_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'SUGGESTED_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'SUGGESTED_GROUPS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'GROUP.EDIT_FULFILLED':
      return update(state, action.payload.groupId, action.payload.entities.groups[action.payload.groupId]);
    case 'CREATE_GROUP_CALENDAR_INVITE_FOR_BROADCAST.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'NESTED_THREAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'NESTED_THREAD.LOAD_DEEP_LINK_TOP_LEVEL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'NESTED_THREAD.LOAD_DEEP_LINK_SECOND_LEVEL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'NESTED_THREAD_LIST.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'TOP_LEVEL_REPLIES.LOAD_INITIAL_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'TOP_LEVEL_REPLIES.LOAD_PREVIOUS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'TOP_LEVEL_REPLIES.LOAD_NEXT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'TOP_LEVEL_REPLIES.LOAD_LAST_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'SECOND_LEVEL_REPLIES.LOAD_PREVIOUS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'SECOND_LEVEL_REPLIES.LOAD_NEXT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'SECOND_LEVEL_REPLIES.LOAD_LAST_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'GROUP.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'USER_SIDEBAR.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'THREAD_SHARES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'GROUP.MARK_AS_OFFICIAL_FULFILLED':
      return updateGroupOfficial(state, action, true);
    case 'GROUP.UNMARK_AS_OFFICIAL_FULFILLED':
      return updateGroupOfficial(state, action, false);
    case 'GROUP.MARK_AS_MTO_GROUP_FULFILLED':
      return updateGroupIsMtoGroup(state, action, true);
    case 'GROUP.UNMARK_AS_MTO_GROUP_FULFILLED':
      return updateGroupIsMtoGroup(state, action, false);
    case 'MY_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'MY_GROUPS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'SUGGESTED_MY_LEADER_GROUPS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'OFFICIAL_GROUPS.LOAD_FULFILLED':
    case 'OFFICIAL_GROUPS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'PUBLISHER.EXTRACT_SUGGESTIONS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    case 'MESSAGE_LANGUAGE_SPECIFIC_CONTENT.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groups);
    default:
      return state;
  }
};

export default reducer;
